import { ItemIdentifiersType, SelectedItemType } from '../types';

export const isMatchForSelectedItem = (
  identifier: ItemIdentifiersType,
  selected: SelectedItemType
) => {
  const idMatch = identifier.id.indexOf(selected.id) > -1;
  const colorMatch = identifier.color === selected.color;
  const sizeMatch = identifier.size?.id === selected.size.id;
  return idMatch && colorMatch && sizeMatch;
};
